import React, { useState, useEffect } from "react";
import { Button, Group, SimpleGrid, Modal, Select } from "@mantine/core";
//import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { apiWithInterceptor } from "../../../../api";
const ShareEventModal = ({ opened, setOpened, eventID }) => {
  const [userId, setUserId] = useState("");
  const [users, setUsers] = useState([]);
  const [privilege, setUserPrivileges] = useState();

  const handleSubmit = () => {
    apiWithInterceptor
      .post("/user-event", {
        user_id: userId,
        event_id: eventID,
        privileges: privilege,
      })
      .then(function (response) {
        showNotification({
          title: ` ${response?.request?.statusText}`,
          message: "Event shared Successfuly",
          color: "green",
        });
        setOpened(false);
      })
      .catch(function (error) {
        showNotification({
          title: "Failed to share event",
          message: ` ${error?.response?.data?.message}`,
          color: "red",
        });
      });
  };

  useEffect(() => {
    apiWithInterceptor
      .get("/user")
      .then((res) => {
        setUsers(res.data.array);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const allUsers = users.map((item) => {
    return {
      value: item.id,
      label: item.username,
    };
  });

  return (
    <>
      <Group position="center">
        <Modal
          title="Share event"
          opened={opened}
          onClose={() => setOpened(false)}
        >
          <SimpleGrid verticalSpacing="lg">
            <Select
              data={allUsers}
              searchable
              nothingFound="No user with this name found"
              label="Share with.."
              placeholder="Select user to share with"
              onChange={(val) => {
                setUserId(val);
              }}
            />

            <Select
              data={[
                { label: "Editor", value: "ADMIN" },
                { label: "Viewer", value: "USER" },
              ]}
              label="Privileges"
              placeholder="Select what the user will do with event"
              onChange={(val) => {
                setUserPrivileges(val);
              }}
            />

            <Button
              fullWidth
              onClick={() => {
                handleSubmit();
              }}
            >
              Share
            </Button>
            <Button
              color="red"
              fullWidth
              onClick={() => {
                setOpened(false);
              }}
            >
              Cancel
            </Button>
          </SimpleGrid>
        </Modal>
      </Group>
    </>
  );
};

export default ShareEventModal;
